module.exports = __webpack_public_path__ + "img/ski_place3.7b5ded74.png";